import {Component, Input} from '@angular/core';
import {ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule, ClrModalModule} from "@clr/angular";
import {NgIf} from "@angular/common";
import {NgxExtendedPdfViewerModule} from "ngx-extended-pdf-viewer";
import {TranslocoDirective} from "@jsverse/transloco";
import {environment as env} from "../../../../../environments/environment";
import { filesBaseUrl } from "../../../../_shared/utils/rest-url";
import {AlertService, FileStoreService, IAlertType} from "../../../../_shared/services";
import {ClarityIcons, timesCircleIcon} from "@cds/core/icon";
import {saveAs} from "file-saver";
import {Files} from "../../../../_shared/interfaces";
import {UploadComponent} from "../../../../core/upload/upload.component";
import { getTenantStorage } from '../../../../_shared/utils/tenant-context';

@Component({
  selector: 'app-delivery-details-documents',
  standalone: true,
  imports: [
    ClrDatagridModule,
    ClrIconModule,
    NgIf,
    ClrModalModule,
    NgxExtendedPdfViewerModule,
    TranslocoDirective,
    UploadComponent
  ],
  templateUrl: './delivery-details-documents.component.html',
  styleUrl: './delivery-details-documents.component.sass'
})
export class DeliveryDetailsDocumentsComponent {
  deliveriesFiles: Files[] = [];
  showPdf = false;
  showFileUpload = false;
  modalContent: string = '';
  modalUrl: string = '';
  loading: boolean = true;
  descSort = ClrDatagridSortOrder.DESC;

  private filesDirectory = filesBaseUrl();

  @Input() projectId: string = '';
  @Input() jobId: number = 0;
  @Input() deliveryId: number = 0;

  constructor(
    private alertDispatcher: AlertService,
    private fileService: FileStoreService,
  ) {
    ClarityIcons.addIcons(timesCircleIcon)
  }

  ngOnInit() {
    this.getFilesSet([5], this.projectId);
  }

  showModal(fileId: string) {
    const phmToken = getTenantStorage('access_token');
    this.modalUrl = `${this.filesDirectory}/download_file?file_id=${fileId}&token=${phmToken}`;
    this.showPdf = true;
  }

  closeModal(state: boolean) {
    this.showFileUpload = state;
    this.loading = true;
    this.getFilesSet([5], this.projectId);
  }

  showFileUploader() {
    this.showFileUpload = true;
  }

  private getFilesSet(docType: number[], projectId: string) {
    this.fileService.getFilesSet(docType, projectId, 0, this.deliveryId).subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.deliveriesFiles = [];
          this.alertDispatcher.alertConfig.message = 'Keine Dateien gefunden!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          return;
        }
        this.deliveriesFiles = data.object;
        this.descSort = ClrDatagridSortOrder.DESC;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return}
    })
  }

  deleteFile(fileId: string, fileName: string) {
    if (confirm('Wollen Sie die Datei ' + fileName + ' wirklich löschen?\nDiese Aktion kann nicht rückgängig gemacht werden!')) {
      this.fileService.deleteFile(fileId)
        .subscribe({
          next: () => {
            this.deliveriesFiles = this.deliveriesFiles.filter(file => file.id !== fileId);
            this.alertDispatcher.alertConfig.message = 'Datei ' + fileName + ' wurde gelöscht. ';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.DANGER;
          },
          complete: () => {
            this.getFilesSet([5], this.projectId);
          },
          error: () => {
            return
          }
        })
    }
  }

  loadFile(fileId: string, fileName: string) {
    if (confirm('Wollen Sie die Datei ' + fileName + ' herunterladen?')) {
      this.fileService.downloadFile(fileId)
        .subscribe({
          next: data => {
            if (!data) {
              this.alertDispatcher.alertConfig.message = 'Keine Datei gefunden!';
              this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
              return;
            }
            saveAs(data, fileName);
          },
          complete: () => {
            this.alertDispatcher.alertConfig.message = 'Datei ' + fileName + ' wurde heruntergeladen. ';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.INFO;
          },
          error: () => {
            return
          }
        })
    }
  }
}
